import { render, staticRenderFns } from "./Affectation.vue?vue&type=template&id=83c4d796&"
import script from "./Affectation.vue?vue&type=script&lang=js&"
export * from "./Affectation.vue?vue&type=script&lang=js&"
import style0 from "./Affectation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports